import api from "../../store/api";
import _ from "lodash"
import { flatClusterLocations } from "./groupedItemHelpers";
import { ILocationByCluster } from "./types/ILocationByCluster";
import ISelectItem from "./types/ISelectItem"
import { setDataToStorage, getDataFromStorage } from "../../common/sessionStorageHelpers"

const filterLocationForPopup = (locationState: any[],
    setSelectedHospital: any,
    setSelectedLocations: any,
    persistName: string | null) => {
    const locations = locationState[0].filter((item: ISelectItem) => item.selected == true).map((item: ISelectItem) => item.value);
    const locationName = locationState[0].filter((item: ISelectItem) => item.selected == true).map((item: ISelectItem) => item.text);
    const selectedHospital = locationName.length == 1 ? locationName[0] : locationName.length > 1 ? `${locationName.length} Hospitals` : "All Hospitals";
    setSelectedHospital(selectedHospital);
    if (persistName !== null) {
        setDataToStorage(persistName, "selectedHospital", selectedHospital);
    }

    if (locations) {
        setSelectedLocations(locations);
        if (persistName !== null) {
            setDataToStorage(persistName, "selectedLocations", locations);
        }
    }
}

const getLocationsForCluster = (clusterId: string, responseDataModel: ILocationByCluster[]): string[] => {
    for (const cluster of responseDataModel) {
        if (!cluster.customerLocations?.length)
            continue;
        const selectedLocations = cluster.customerLocations.filter(loc => loc.clusterId === clusterId).map(loc => loc.locationId);
        if (selectedLocations.length) {
            return selectedLocations;
        }
    }
    return [];
}

const getLocationsDataForPopup = async (locationState: any[],
    setSelectedHospital: any,
    setSelectedLocations: any,
    selectedLocations: any,
    persistName: string | null,
    clusterId?: string | null): Promise<void> => {

    if (clusterId && persistName) {
        clusterId = null;
        console.error('Persistence and cluster filter are not supported together yet');
    }

    try {
        const res = await api.getLocationGroupedByClusters('version='+Math.random().toString()+Math.random().toString()+Math.random().toString());
        const responseDataModel: ILocationByCluster[] = res.data.model;        
        if (clusterId && !selectedLocations?.length) {
            selectedLocations = getLocationsForCluster(clusterId, responseDataModel);
        }

        let locationsClusters: ISelectItem[] = flatClusterLocations(responseDataModel, selectedLocations);

        // if only one location => set it as filter
        if (responseDataModel.length === 1 && responseDataModel[0].customerLocations.length === 1) {
            const foundOneLocation = locationsClusters.find(q => q.value === responseDataModel[0].customerLocations[0].locationId);
            if (foundOneLocation) {
                foundOneLocation.selected = true;
                if (persistName !== null) setDataToStorage(persistName, "selectedHospital", foundOneLocation.text);
            }
        }

        locationState[1](locationsClusters);

        const locations = locationsClusters.filter((item: ISelectItem) => item.selected).map((item: ISelectItem) => item.value ?? "");
        if (locations && !_.isEqual(_.sortBy(locations), _.sortBy(selectedLocations))) {
            setSelectedLocations(locations);
        }

        if (locations.length === 1) {
            if (persistName !== null) setSelectedHospital(getDataFromStorage(persistName, "selectedHospital"));
        } else if (locations.length === 0) {
            setSelectedHospital("All Hospitals");
            if (persistName !== null) setDataToStorage(persistName, "selectedHospital", "All Hospitals");
        } else if (locations.length > 1) {
            setSelectedHospital(`${locations.length} Hospitals`);
            if (persistName !== null) setDataToStorage(persistName, "selectedHospital", `${locations.length} Hospitals`);
        }
    }
    catch (err) {
        setSelectedHospital("All Hospitals");
        if (persistName !== null) setDataToStorage(persistName, "selectedHospital", "All Hospitals");
    }
}

export {
    filterLocationForPopup,
    getLocationsDataForPopup
}